import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://gqifqfctsuizbylezfmo.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdxaWZxZmN0c3VpemJ5bGV6Zm1vIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY2OTA1NjQ1MiwiZXhwIjoxOTg0NjMyNDUyfQ.VILWhMSywYdV9aD4HfEfwLvyMCpDmZbBAn5TTPtt9r0";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
